let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("5uoHm"), load("bvn86")]).then(() => parcelRequire('7xDLz'));